import React, { useEffect, useState } from 'react'
import {
  Edit,
  SimpleForm,
  TextInput,
  BooleanInput,
  useTranslate,
  useEditController,
  useNotify,
  useRedirect,
  required,
} from 'react-admin'
import { Grid, Skeleton } from '@mui/material'
import { CardCommon } from 'src/components/uiElements'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { applicationServices } from 'src/services/auth/application/application.service'
import { CardCrudBottomButtons } from 'src/components/uiElements/CRUD/CardCrudBottomButtons'
import { moduleServices } from 'src/services/auth/module/module.service'
import { SelectInput } from 'src/components/uiElements/fields/SelectInput'
import { entityServices } from 'src/services/auth/entity/entity.service'

export const PermissionEdit = (props) => {
  const translate = useTranslate()
  const notify = useNotify()
  const redirect = useRedirect()
  const [applications, setApplications] = useState([])
  const [loadingApplications, setLoadingApplications] = useState(true)
  const [modules, setModules] = useState([])
  const [loadingModules, setLoadingModules] = useState(true)
  const [entities, setEntities] = useState([])
  const [loadingEntities, setLoadingEntities] = useState(false)
  const { record } = useEditController({ resource: 'permission', id: props.id })

  useEffect(() => {
    if (record) {
      getApplications()
      getEntities()

      if (record.module) {
        record.application_id = record.module.application_id
        getModulesByApplication(record.module.application_id)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [record])

  const getApplications = async () => {
    setLoadingApplications(true)
    try {
      const allAplications = await applicationServices.getByAll()
      if (allAplications) {
        setApplications(allAplications)
        setLoadingApplications(false)
        return
      }
      notify(`applications not found`, { type: 'error' })
      setLoadingApplications(false)
    } catch (error) {
      notify(`please, refresh page`, { type: 'error' })
      setLoadingApplications(false)
    }
  }

  const getEntities = () => {
    ;(async () => {
      setLoadingEntities(true)
      try {
        const allAplications = await entityServices.getByAll()
        setEntities(allAplications)
        setLoadingEntities(false)
      } catch (error) {
        notify(`please, refresh page`, { type: 'error' })
        setLoadingEntities(false)
      }
    })()
  }

  const getModulesByApplication = async (idApplication) => {
    setLoadingModules(true)
    try {
      if (idApplication) {
        let allModules = await moduleServices.getModulesByApplications(idApplication)
        setModules(allModules)
        setLoadingModules(false)
        return
      }
      setModules([])
      setLoadingModules(false)
    } catch (error) {
      notify(`please, refresh page`, { type: 'error' })
      setModules([])
      setLoadingModules(false)
    }
  }

  const transform = (data) => ({
    id: data.id,
    action: data.action,
    entity_id: data.entity_id,
    description: data.description,
    module_id: data.module_id,
    start_icon: data.start_icon,
    menu: data.menu,
  })

  const onSuccess = () => {
    notify('ra.notification.updated_success_masculine', {
      type: 'success',
      messageArgs: { element: translate('ra.single_entity.permission') }
    })
    redirect('/permission')
  }

  const onError = () => {
    notify('ra.notification.updated_error_masculine', {
      type: 'error',
      messageArgs: { element: translate('ra.single_entity.permission') }
    })
  }

  return (
    <Edit
      {...props}
      transform={transform}
      mutationMode='pessimistic'
      mutationOptions={{ onSuccess, onError }}
      actions={null}
    >
      <CardCommon title={translate('ra.title.update_permission')}>
        <SimpleForm toolbar={<CardCrudBottomButtons btnSave={true} btnDelete={true} fieldsName={['description']} genderElement='masculine' />}>
          <Grid container spacing={3}>
            <EditInputsWrap label={translate('ra.field.action')} required>
              <TextInput variant='outlined' label='' source='action' fullWidth validate={[required()]} />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.start_icon')}>
              <TextInput label='' source='start_icon' fullWidth />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.application')} required>
              {loadingApplications ? (
                <Skeleton variant='rectangular' width={'100%'} height={40} />
              ) : (
                <SelectInput
                  source='application_id'
                  defaultValue={record?.application_id}
                  optionsText={['long_name']}
                  label=''
                  fullWidth
                  options={applications}
                  onChange={(e) => {
                    record.module_id = null
                    getModulesByApplication(e.target.value)
                  }}
                  validate={required()}
                />
              )}
            </EditInputsWrap>

            <EditInputsWrap label={translate('ra.field.module')} required>
              {loadingModules ? (
                <Skeleton variant='rectangular' width={'100%'} height={40} />
              ) : (
                <SelectInput
                  source='module_id'
                  defaultValue={record?.module_id}
                  optionsText={['long_name']}
                  options={modules}
                  label=''
                  fullWidth
                  validate={required()}
                />
              )}
            </EditInputsWrap>

            <EditInputsWrap label={translate('ra.field.description')}>
              <TextInput label='' source='description' fullWidth />
            </EditInputsWrap>

            <EditInputsWrap label={translate('ra.field.entity')} required>
              {loadingEntities ? (
                <Skeleton variant='rectangular' width={'100%'} height={40} />
              ) : (
                <SelectInput
                  source='entity_id'
                  defaultValue={record?.entity_id}
                  optionsText={['name']}
                  options={entities}
                  label=''
                  fullWidth
                  validate={required()}
                />
              )}
            </EditInputsWrap>

            <EditInputsWrap label={translate('ra.field.menu')}>
              <BooleanInput fullWidth label={translate('ra.field.menu')} source='menu' />
            </EditInputsWrap>
          </Grid>
        </SimpleForm>
      </CardCommon>
    </Edit>
  )
}
